<template>
  <v-dialog v-model="internalDialog" max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">{{title}}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                color="orange"
                v-model="newLabel"
                label="Color's Label"
                outlined />
            </v-col>
            <v-col>
              <v-row justify="center">
                <v-color-picker v-model="newCode" elevation="5"></v-color-picker>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="orange" text @click="internalDialog = false" >
          Cancel
        </v-btn>
        <v-btn color="orange" text @click="onSubmit" >
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AddColorModal',
  props: ['dialog', 'title'],

  data () {
    return {
      newCode: '#FF0000',
      newLabel: ''
    }
  },

  computed: {
    internalDialog: {
      get () {
        return this.dialog
      },
      set (val) {
        if (!val) {
          this.newCode = '#FF0000'
          this.newLabel = ''
          this.$emit('close')
        }
      }
    }
  },

  methods: {
    onSubmit () {
      this.$emit('addColor', {
        code: this.newCode,
        label: this.newLabel
      })
      this.internalDialog = false
    }
  }
}
</script>
